
import { defineComponent, nextTick, onMounted } from "vue";
import { useStore } from "vuex";
import { Mutations } from "@/store/enums/StoreEnums";
import { initializeComponents } from "@/core/plugins/keenthemes";
import "flag-icons/css/flag-icons.min.css";
import ShowRowActions from  '@/components/custom/common/ShowRowActions.vue'
import TransactionServices from "@/services/TransactionServices"
import AccountService from "@/services/AccountServices"
import { useToast } from "vue-toastification";

import {mapActions} from "vuex"
export default defineComponent({
  name: "app",
  components:{ShowRowActions},
  setup() {
    const store = useStore();

    onMounted(() => {
      /**
       * this is to override the layout config using saved data from localStorage
       * remove this to use config only from static config (@/core/config/DefaultLayoutConfig.ts)
       */
      store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);

      nextTick(() => {
        initializeComponents();
      });
    });
  },

  data(){
    const toast = useToast();

    var displayDialog:any
    return {
      toast,
      showDialog:false,
      actions:'',
      displayDialog,

       accountList: [],
      authenticators: {},
      selectedAccount: {},
      selectedAccountTemp:"",
    }
  },

  mounted(){
    TransactionServices.showpopUp = this.openDialog
  },
  
  methods:{
    ...mapActions(['setUserAccounts']),
    ...mapActions(['changeSelectedAccount']),


    closeDialog(){
      this.showDialog = false
    },
    openDialog(data:any){
      this.actions=data
      this.showDialog = true
    }
    },
});
